import React, {useEffect} from 'react';
import '../../App.css';
import Cards from '../Cards';
import HeroSection from '../HeroSection';
import Footer from '../Footer';
import { Button } from '../Button';
import '../SignupForm.css';
import { FaBeer } from "@react-icons/all-files/fa/FaBeer";
import { MdContactPhone } from "@react-icons/all-files/md/MdContactPhone";
import { FiPhoneCall } from "react-icons/fi"; 
import { BsFillCalendarCheckFill } from "react-icons/bs";
import '../../font/Karla-Bold.ttf';

function Home() {
 
  return (
    <>
        <>
  
   

  <div className='section2'>
      <div className='area-1'>
        <div className='description'>
          <h1>Dr. Rachel Boim, DPT, PhD</h1>
          <div className='data-1'>
            <p>Dr. Rachel Boim, DPT, PhD is a 
              licensed physical therapist. 
              She has worked around the world and can help you recover from injury and improve your mobility via online sessions or in-person body-work.
            </p>
        </div>
  
        <div className='btn-area'>
          <div className='btn-div'>
        <Button
            className='btns'
            buttonStyle='testBtn'
            buttonSize='btn--modify'
            onClick={() => { window.location.href = 'https://chaski.run/contact'; } }
          >
  
          <div className='logo'>
              <FiPhoneCall /> 
            </div>
            <div className='btn-text'>
            CONTACT
            </div>
  
         
          </Button>
          </div>
        
          <div className='btn-div'>
       <Button
            className='btns'
            buttonStyle='testBtn'
            buttonSize='btn--modify'
            onClick={() => { window.location.href = 'https://chaski.run/biochemical-analysis'; } }
          >
            <div className='logo'>
              <BsFillCalendarCheckFill /> 
            </div>
            <div className='btn-text'>
              BOOK A SESSION 
            </div>
           
           
          </Button>
          
          </div>
        </div>

    
  
        
        </div>
        
      </div>
      <div className='area-2'>
      <div className='image'>
          <img src='images/test.png'  className='img-file' alt='image'></img>
        </div>
      </div>
  </div>
  </>

    </>
  );
}

export default Home;
